import { FC } from "react";
import Link from "next/link";
import { useTranslation } from "react-i18next";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { FullWidthLayout } from "@/layouts";
import { TitleContainer, SectionTitle } from "../home.styles";
import { ButtonMui } from "@/components/ui";
import * as Styled from "./freeTrial.styles";

const FreeTrialScreen: FC = () => {
  const { t } = useTranslation("global");
  return (
    <FullWidthLayout id="freetrial">
      <Styled.FreeTrialContainer>
        <Styled.FreeTrialBox>
          <TitleContainer>
            <SectionTitle
              className="display-medium"
              color="var(--on-surface-light)"
            >
              {t("freeTrial.title")}
            </SectionTitle>
            <Styled.FlagText className="display-large weight-medium">
              {t("freeTrial.flag")}
            </Styled.FlagText>
            <Styled.FreeTrialText className="body-large">
              {t("freeTrial.description")}
            </Styled.FreeTrialText>
            <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <ButtonMui
                variant="contained"
                size="medium"
                color="primary"
                endIcon={<ArrowForwardIcon />}
              >
                <Link href="/freetrial">{t("freeTrial.button")}</Link>
              </ButtonMui>
            </div>
          </TitleContainer>
        </Styled.FreeTrialBox>
      </Styled.FreeTrialContainer>
    </FullWidthLayout>
  );
};

export default FreeTrialScreen;
